/* bundle builder */
try {
  $(function () {
    const numberOfSteps = parseInt(
      $(".product-bundle-popup").attr("data-numberofstep")
    );
    function bundleProductClose() {
      $(".product-bundle-popup-overlay").removeClass("open");
      $(".product-bundle-popup").removeClass("open");
    }
    function stepProducts(step) {
      var originalStep = step;
      if (step) {
        var step = step;
        $(".product-bundle-products-selection").each(function () {
          var firstBlank = $(this).find(
            ".product-bundle-add-product:not(.added):first"
          );
          $(".product-bundle-add-product").removeClass("first-blank");
          $(firstBlank).addClass("first-blank");
          step = $(firstBlank).attr("data-step");
        });
        step = step ? step : originalStep;
        if (originalStep) {
          step = originalStep;
        }
        $(
          ".bundle-popup-products .bundle-popup-products-block-wrapper"
        ).removeClass("open");
        let el = $(
          ".bundle-popup-products-block-wrapper[data-step='" + step + "']"
        );
        $(el).addClass("open");
      }
    }
    function bundleProductOpen(step) {
      $(".product-bundle-popup-overlay").addClass("open");
      $(".product-bundle-popup").addClass("open");
      $(
        ".bundle-popup-products .bundle-popup-products-block-wrapper"
      ).removeClass("open");

      if (step) {
        stepProducts(step);
      } else {
        $(".bundle-popup-products .bundle-popup-products-block-wrapper")
          .eq(0)
          .addClass("open");
      }
    }
    $(".product-bundle-popup-overlay").click(function () {
      bundleProductClose();
    });
    $(".bundle-popup-products-block-btn").click(function (e) {
      document.querySelector("#AddToCart").click();
      setTimeout(function () {
        bundleProductClose();
      }, 2000);
    });
    $(".bundle-popup-close").click(function (e) {
      bundleProductClose();
    });
    $(".product-bundle-add-product").click(function (e) {
      bundleProductOpen($(this).attr("data-step"));

      stepProducts($(this).attr("data-step"));

      $(".product-bundle-add-product").removeClass("first-blank");
      var that = this;
      $(".product-bundle-products-selection").each(function () {
        var getClicked = $(this)
          .find(".product-bundle-add-product")
          .eq($(that).index());
        $(getClicked).addClass("first-blank");
      });
    });
    function setActiveProduct(vid, title, img, step) {
      $(".product-bundle-products-selection").each(function () {
        var removeEl = $(this).find(
          `.product-bundle-add-product[data-step="${step}"]`
        );
        $(removeEl).removeClass("added");
        $(removeEl).removeAttr("data-vid");
        $(removeEl).find(".p-img").remove();
        $(removeEl).find(".p-title").remove();
      });

      $(".product-bundle-products-selection").each(function () {
        var firstElement = $(
          `.product-bundle-add-product[data-step="${step}"]:not(.added)`
        );
        firstElement.addClass("added");
        $(firstElement).attr("data-vid", vid);
        const pimg = `<img src="${img}" class="p-img">`;
        const ptitle = `<p class="p-title">${
          title.length > 35 ? title.substring(0, 25) + "..." : title
        }</p>`;
        $(firstElement).find(".product-bundle-add-product-img").append(pimg);
        firstElement.append(ptitle);

        var firstBlank = $(this).find(
          ".product-bundle-add-product:not(.added):first"
        );
        stepProducts($(firstBlank).attr("data-step"));
      });
    }
    function removeActiveProduct(varaintId, index) {
      let foundFirst = false;

      activeProducts = activeProducts.filter((el) => {
        if (!foundFirst && el.vid == varaintId) {
          foundFirst = true;
          return false;
        }
        return true;
      });

      $(".product-bundle-products-selection").each(function () {
        var removeEl = $(this).find(".product-bundle-add-product").eq(index);
        $(removeEl).removeClass("added");
        $(removeEl).removeAttr("data-vid");
        $(removeEl).find(".p-img").remove();
        $(removeEl).find(".p-title").remove();
      });

      updateDOM(activeProducts);
    }
    function updateDOM(activeProducts) {
      let activeProductsLength = activeProducts.length;
      $(".number-of-selected-items").text(activeProductsLength);
      let percent = (activeProductsLength / numberOfSteps) * 100;
      $(".product-bundle-popup .progress-bar-fill").css({
        width: percent + "%",
      });
      var buttons = document.querySelectorAll(
        ".bundle-popup-products-block-btn"
      );
      if (activeProductsLength == numberOfSteps) {
        $(".bundle-popup-products-block-btn").removeAttr("disabled");
        $(".product-bundle-wrapper").addClass("filled");
        $(".product__info #AddToCart").removeAttr("disabled");

        buttons.forEach((button) => {
          const dataText = "Set in den Warenkorb packen";

          button.textContent = dataText;
        });
      } else {
        $(".product-bundle-wrapper").removeClass("filled");
        // $(".bundle-popup-products-block-btn").attr("disabled", true);
        // $(".product__info #AddToCart").attr("disabled", true);

        buttons.forEach((button) => {
          const dataText = button.getAttribute("data-text");

          button.textContent = dataText;
        });
      }

      var productPrice =
        parseFloat(
          document
            .querySelector(".price-list [data-ed-price]")
            .getAttribute("data-ed-price")
        ) / 100;
      var total = productPrice;
      var additionalPrices = []; // Speichert nur die Preise der Zusatzprodukte

      // Der initiale Text wird später definiert, basierend darauf, ob Zusatzoptionen vorhanden sind
      var temp = "";

      activeProducts.forEach(function (el) {
        if (el.price > 0) {
          additionalPrices.push(el.price.toFixed(2) + "€"); // Fügt nur den Preis hinzu, wenn er größer als 0 ist
          total += parseFloat(el.price);
        }
      });

      // Zusätzliche Preise in den String einfügen, falls vorhanden
      if (additionalPrices.length > 0) {
        var additionalPricesString = additionalPrices.join(" + ");
        temp = `<strong>Set:</strong> ${productPrice}€ + Auswahl: ${additionalPricesString} = <strong class="final-price">${total.toFixed(
          2
        )}€</strong>`;
      } else {
        // Zeigt nur den Basispreis an, wenn keine Zusatzoptionen über 0€ gewählt wurden
        temp = `<strong>Set:</strong> ${productPrice}€`;
      }

      // Verwendung von .html() um sicherzustellen, dass HTML-Tags korrekt interpretiert werden
      $(".product-bundle-popup-header-left").html(temp);
    }
    $(".bundle-popup-products-block-product").click(function (e) {
      e.preventDefault();
      var stepAdded = false;

      let step = $(this).attr("data-step");

      for (let item of activeProducts) {
        if (item.step == step) {
          stepAdded = true;
        }
      }

      if (!$(this).hasClass("soldout")) {
        let vid = $(this).attr("data-vid");
        let title = $(this).attr("data-title");
        let img = $(this).attr("data-img");
        let price = parseFloat(
          $(this).find(".bundle-product-price").text().replace(",", ".")
        );
        let optional = $(this).attr("data-optional") === "1" ? true : false;

        activeProducts = activeProducts.filter(function (item) {
          return item.step !== step;
        });

        if (activeProducts.length != numberOfSteps) {
          activeProducts.push({
            vid,
            title,
            img,
            step,
            price,
            optional,
          });
          setActiveProduct(vid, title, img, step);
          updateDOM(activeProducts);
        } else {
        }
      }
    });

    $(".bundle-product-cross").click(function (e) {
      e.preventDefault();
      let parent = $(this).parents(".product-bundle-add-product");
      removeActiveProduct($(parent).attr("data-vid"), $(parent).index());
    });
  });
} catch (e) {
  console.log(e);
}

/* bundle builder */

/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./src/js/modules/ed-video-component.js":
/*!**********************************************!*\
  !*** ./src/js/modules/ed-video-component.js ***!
  \**********************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var EdVideoThumbnail = /*#__PURE__*/function (_HTMLElement) {
  _inherits(EdVideoThumbnail, _HTMLElement);

  var _super = _createSuper(EdVideoThumbnail);

  function EdVideoThumbnail() {
    var _this;

    _classCallCheck(this, EdVideoThumbnail);

    _this = _super.call(this); // SELECTORS

    _this.popUp = document.querySelector('.video-popup-container');
    _this.popUpVideo = _this.popUp.querySelector('.video-container'); // video inside of popup

    _this.openButton = _this.querySelector('.btn-open');
    _this.closeButton = _this.popUp.querySelector('.btn-close');
    _this.playButton = _this.querySelector('.play-btn'); // ENABLE EXTERNAL POPUP ELEMENT

    if (_this.popUp) {
      document.querySelector('ed-video-popup').setAttribute('enabled', '');
    } // SETUP EVENT LISTENERS


    _this._attachListeners();

    return _this;
  }

  _createClass(EdVideoThumbnail, [{
    key: "videoSrc",
    get: function get() {
      return this.getAttribute('video-src');
    }
  }, {
    key: "autoPlay",
    get: function get() {
      return this.getAttribute('autoplay');
    }
  }, {
    key: "controls",
    get: function get() {
      return this.getAttribute('controls');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      document.addEventListener('keydown', this.closeOnEsc.bind(this));
      this.openButton.addEventListener('click', this.openPopup.bind(this));
      this.playButton.addEventListener('click', this.openPopup.bind(this)); // click outside

      this.popUp.addEventListener('click', this.closePopup.bind(this));
      this.closeButton.addEventListener('click', this.closePopup.bind(this));
    }
  }, {
    key: "openPopup",
    value: function openPopup(e) {
      e.stopPropagation();
      this.createVideo();
      this.popUp.classList.add('open');
      document.documentElement.classList.add('ed-video-popup-open');
    }
  }, {
    key: "closePopup",
    value: function closePopup(e) {
      e.stopPropagation();
      this.popUpVideo.innerHTML = '';
      this.popUp.classList.remove('open');
      document.documentElement.classList.remove('ed-video-popup-open');
    }
  }, {
    key: "closeOnEsc",
    value: function closeOnEsc(e) {
      if (e.key === 'Escape') {
        this.popUpVideo.innerHTML = '';
        document.documentElement.classList.remove('ed-video-popup-open');
        this.popUp.classList.remove('open');
      }
    }
  }, {
    key: "createVideo",
    value: function createVideo() {
      var video = document.createElement('video');
      video.src = this.videoSrc;
      /** settings **/

      video.autoplay = true;
      video.controls = true;

      if (this.autoPlay === 'false') {
        video.autoplay = false;
      }

      if (this.controls === 'false') {
        video.controls = false;
      }

      this.popUpVideo.appendChild(video);
    }
  }]);

  return EdVideoThumbnail;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

customElements.define('ed-video-thumbnail', EdVideoThumbnail);

var EdVideoPopup = /*#__PURE__*/function (_HTMLElement2) {
  _inherits(EdVideoPopup, _HTMLElement2);

  var _super2 = _createSuper(EdVideoPopup);

  function EdVideoPopup() {
    _classCallCheck(this, EdVideoPopup);

    return _super2.call(this);
  }

  return _createClass(EdVideoPopup);
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

customElements.define('ed-video-popup', EdVideoPopup);

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
var __webpack_exports__ = {};
/*!**************************!*\
  !*** ./src/js/custom.js ***!
  \**************************/
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _modules_ed_video_component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./modules/ed-video-component */ "./src/js/modules/ed-video-component.js");
/* harmony import */ var _modules_ed_video_component__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_video_component__WEBPACK_IMPORTED_MODULE_0__);
/*
DO NOT TOUCH THIS FILE OUTSIDE OF /src DIRECTORY
this file gets compiled ./assets/custom.js - make sure to import every module here.
*/

})();

// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
/*!******************************!*\
  !*** ./src/scss/custom.scss ***!
  \******************************/
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin

})();

/******/ })()
;

async function _addToCart(variantId, quantity) {
  const productForm = new FormData();
  productForm.append("sections", ["mini-cart"]);
  productForm.append("items[0][id]", variantId);
  productForm.append("items[0][quantity]", quantity);
  const response = await fetch(
    `${window.themeVariables.routes.cartAddUrl}.js`,
    {
      body: productForm,
      method: "POST",
      headers: {
        "X-Requested-With": "XMLHttpRequest",
      },
    }
  );

  const responseJson = await response.json();
  if (response.ok) {
    this.dispatchEvent(
      new CustomEvent("variant:added", {
        bubbles: true,
        detail: {
          variant: responseJson.hasOwnProperty("items")
            ? responseJson["items"][0]
            : responseJson,
        },
      })
    );
    fetch(`${window.themeVariables.routes.cartUrl}.js`).then(
      async (response2) => {
        const cartContent = await response2.json();
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:updated", {
            bubbles: true,
            detail: {
              cart: cartContent,
            },
          })
        );
        cartContent["sections"] = responseJson["sections"];
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:refresh", {
            bubbles: true,
            detail: {
              cart: cartContent,
              openMiniCart:
                window.themeVariables.settings.cartType === "drawer" && false,
            },
          })
        );
      }
    );
  }
}
// Additional warranty item api
document.documentElement.addEventListener("cart:updated", handleCartUpdate);

const blockBtns = (show) => {
  const btns = document.querySelectorAll(
    "#mini-cart-form .line-item__quantity "
  );
  btns.forEach((btn) => {
    btn.style.pointerEvents = show ? "visible" : "none";
  });
};
async function handleCartUpdate() {
  try {
    blockBtns(false);
    setTimeout(async function(){
      await ensureAdditionalWarrantyItems();
      console.log("Cart update handled.");  
    }, 500)
    
  } catch (error) {
    console.error("Fehler bei der Aktualisierung des Warenkorbs:", error);
  }
}

async function ensureAdditionalWarrantyItems() {
  const customCart = await fetchCustomCart();

  const additionalWarrantyItemId = customCart?.additional_warranty_item?.id;
  if (!additionalWarrantyItemId) return;

  // Remove non product associated warranty products if any
  const cart_item_names = customCart.items.map(function(item){
    return item.title;
  })
  
  const nonAssociatedWarrantyProductsLineKeys = customCart.items.filter(function(item){   
    return item.id === additionalWarrantyItemId && item.properties_Product && !cart_item_names.includes(item.properties_Product)
  }).map(function(item){
    return item.key;
  })

  for(item_key of nonAssociatedWarrantyProductsLineKeys){
    await updateCartRaw({ [item_key]: 0 }) 
  }

  for(let item of customCart.items){
    const name = item.title;
    const quantity = item.quantity;

    if(item.require_additional_warranty)
    {
      // Check how many quantity are in cart and how many should be
      const current = getCurrentAdditionalWarrantyItemCountForProduct(customCart, additionalWarrantyItemId, name)

      if(current.count !== quantity){
        if(current.count > 0){
          await updateCartRaw({ [current.item_key]: quantity })  
        }else{
          if(item.automatic_warranty_add){
            let formData = {
             'items': [{
              'id': additionalWarrantyItemId,
              'quantity': quantity,
                properties: {
                  'Product': name
                }
              }]
            };
            await addCartRaw(formData)  
          }
        }
      }
    }
  }
}

async function fetchCustomCart() {
  const response = await fetch(
    `${window.themeVariables.routes.rootUrl}?view=cart`
  );
  return response.json();
}

function calculateRequiredAdditionalWarrantyItems(cart, additionalWarrantyItemId) {
  return cart.items.reduce((count, item) => {
    return item.require_additional_warranty ? count + item.quantity : count;
  }, 0);
}

function getCurrentAdditionalWarrantyItemCount(cart, additionalWarrantyItemId) {
  return cart.items.reduce((count, item) => {
    return item.id === additionalWarrantyItemId ? count + item.quantity : count;
  }, 0);
}


function getCurrentAdditionalWarrantyItemCountForProduct(cart, additionalWarrantyItemId, name) {
  let item_key = null
  const count = cart.items.reduce((count, item) => {
    if(item.id === additionalWarrantyItemId && item.properties_Product === name){
      item_key = item.key
      return count + item.quantity;
    }
    return count;
  }, 0);

  return {item_key, count}
}


async function addCartRaw(formData) {
  const response = await fetch(
    `${window.themeVariables.routes.cartUrl}/add.js`,
    {
      body: JSON.stringify({
        sections: ["mini-cart"],
        ...formData,
      }),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    }
  );

  if (!response.ok) {
    throw new Error(
      `Fehler beim Abrufen von Warenkorbdaten. Statuscode: ${response.status}`
    );
  }

  const cartContent = await response.json();
  await dispatchCartEvent("cart:updated", cartContent);
  await dispatchCartEvent("cart:refresh", cartContent);
  blockBtns(true);
}

async function updateCartRaw(updates) {
  const response = await fetch(
    `${window.themeVariables.routes.cartUrl}/update.js`,
    {
      body: JSON.stringify({
        sections: ["mini-cart"],
        updates,
      }),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    }
  );

  if (!response.ok) {
    throw new Error(
      `Fehler beim Abrufen von Warenkorbdaten. Statuscode: ${response.status}`
    );
  }

  const cartContent = await response.json();
  await dispatchCartEvent("cart:updated", cartContent);
  await dispatchCartEvent("cart:refresh", cartContent);
  blockBtns(true);
}

async function updateCart(additionalWarrantyItemId, requiredQuantity) {
  const response = await fetch(
    `${window.themeVariables.routes.cartUrl}/update.js`,
    {
      body: JSON.stringify({
        sections: ["mini-cart"],
        updates: { [additionalWarrantyItemId]: requiredQuantity },
      }),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    }
  );

  if (!response.ok) {
    throw new Error(
      `Fehler beim Abrufen von Warenkorbdaten. Statuscode: ${response.status}`
    );
  }

  const cartContent = await response.json();
  await dispatchCartEvent("cart:updated", cartContent);
  await dispatchCartEvent("cart:refresh", cartContent);
  blockBtns(true);
}

async function dispatchCartEvent(eventName, cartContent) {
  document.documentElement.dispatchEvent(
    new CustomEvent(eventName, {
      bubbles: true,
      detail: { cart: cartContent },
    })
  );
}

// Initialer Aufruf
ensureAdditionalWarrantyItems();

function ensureWarrantyProductInputName(product_form){
  const warrantyCheckbox = document.querySelector('input.additional-warrenty-item')
  if(warrantyCheckbox && product_form){
    if(warrantyCheckbox.checked){
      product_form.querySelector('.additional_warrenty_container input.warranty-product-input').name = 'items[1][properties][Product]'
      product_form.querySelector('.additional_warrenty_container input.warranty-product-selling-plan-input').name = 'items[1][selling_plan]'
    }else{
      product_form.querySelector('.additional_warrenty_container input.warranty-product-input').name = ''
      product_form.querySelector('.additional_warrenty_container input.warranty-product-selling-plan-input').name = ''
    }
  }
}

document.querySelectorAll('.additional-warrenty-item').forEach(function(node){
  node.addEventListener('change', function(e){
    ensureWarrantyProductInputName(e.target.closest('.product-form'))
  })
})

document.addEventListener('variant:changed', function(e){
  const warrantyProductInput = e.target?.closest('.product-form')?.querySelector('.additional_warrenty_container .warranty-product-input')
  if(warrantyProductInput){
    e.target.closest('.product-form').querySelector('.additional_warrenty_container .warranty-product-input').value = e.detail.variant.name
  }

  if(warrantyProductInput){
    ensureWarrantyProductInputName(e.target.closest('.product-form'))
  }
});